import { IconInfoCircle } from "@tabler/icons-react";
import type { FC } from "react";
import { Button as AriaButton, type ButtonProps } from "react-aria-components";
import { twMerge } from "tailwind-merge";

export interface InfoButtonProps extends Omit<
  ButtonProps,
  "children" | "className"
> {
  className?: string;
}

/**
 * A small info-circle icon button. Renders a react-aria `Button`, so it can be
 * the trigger of a `DialogTrigger` (modal or popover). Callers supply the reveal
 * styling (e.g. `opacity-0 group-hover:opacity-100`) via `className`.
 */
export const InfoButton: FC<InfoButtonProps> = ({ className, ...props }) => (
  <AriaButton
    {...props}
    className={twMerge(
      "shrink-0 rounded-full text-gray-400 transition hover:text-gray-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
      className,
    )}
  >
    <IconInfoCircle className="size-4" />
  </AriaButton>
);
